var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('iframe',{attrs:{"id":"footer-iframe","src":"https://www.dssn.com.au/events-footer/","width":"","height":"","scrolling":"no"}})])
}]

export { render, staticRenderFns }